import { ReactComponent as SandClockIcon } from '@Icons/additional/sandclock.svg';
import styles from './request-header.module.css';

const RequestHeaderDetailsSection: React.FC = () => {
  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <div>
          <SandClockIcon />
        </div>
        <div className={styles.textSection}>
          <span className={styles.caption}>
            Awaiting Request Header Details
          </span>
          <span className={styles.description}>
            We will generate a preview of the details you provide to keep as a
            reference
          </span>
        </div>
      </div>
    </div>
  );
};

export default RequestHeaderDetailsSection;
